const locale = {
  common: {
    loading: "Wird geladen...",
    error: "Fehler: {{message}}",
    noDataFound: "Keine Daten gefunden",
    search: "Suchen",
    actions: "Aktionen",
    save: "Speichern",
    saving: "Wird gespeichert...",
    update: "Aktualisieren",
    updating: "Wird aktualisiert...",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    create: "Erstellen",
    submit: "Absenden",
    close: "Schließen",
    previous: "Zurück",
    next: "Weiter",
    page: "Seite {{current}} von {{total}}",
    confirmation: "Bestätigung",
    yes: "Ja",
    no: "Nein",
    user: "Benutzer",
    errorObj: {
      fieldRequired: "Dieses Feld ist erforderlich",
      connectionError: "Verbindungsfehler",
      unknownError: "Unbekannter Fehler"
    },
    notSpecified: "Nicht angegeben",
    refresh: "Aktualisieren",
    copied: "Kopiert!",
    filter: "Filter",
    generate: "Generieren",
    current: "Aktuell",
    undo: "Rückgängig"
  },
  navigation: {
    dashboard: "Dashboard",
    pharmacies: "Apotheken",
    users: "Benutzer",
    settings: "Einstellungen",
    logout: "Abmelden",
    profileSettings: "Profileinstellungen",
    profile: "Profil",
    changePassword: "Passwort ändern",
    categories: "Kategorien",
    labTests: "Labortests",
    dnaSamples: "PDFs hochladen",
    testResults: "Testergebnisse",
    tutorials: "Tutorials",
  },
  sidebar: {
    administrator: "Administrator",
    mainNavigation: "Hauptnavigation",
    version: "somaplus Admin Dashboard v{{version}}",
  },
  dashboard: {
    title: "Dashboard",
    selectDate: "Datum auswählen",
    refreshData: "Daten aktualisieren",
    totalPharmacies: "Gesamtanzahl der Apotheken",
    activePharmacies: "Aktive Apotheken",
    totalRevenue: "Gesamteinnahmen",
    totalUsers: "Gesamtanzahl der Benutzer",
    lastUpdated: "Zuletzt aktualisiert",
    totalCancelledBooking: "Stornierte Buchungen",
    totalOpenBooking: "Offene Buchungen",
    totalPerformedTests: "Durchgeführte Tests",
    pharmacies: "Apotheken",
    selectPharmacy: "Apotheke auswählen",
    loadingPharmacies: "Apotheken werden geladen...",
    testsUnderPharmacy: "Tests unter {{name}}",
    totalTestsCompleted: "Abgeschlossene Tests gesamt",
    staffBookings: "Mitarbeiter-Buchungen",
    nonStaffBookings: "Nicht-Mitarbeiter-Buchungen",
    totalCount: "Gesamtanzahl",
    staffCount: "Mitarbeiter",
    nonStaffCount: "Nicht-Mitarbeiter",
    noTestRecords: "Keine Testdaten für diese Apotheke verfügbar",
    testCountsPeriodHint: "Zahlen basieren auf abgeschlossenen Tests im gewählten Zeitraum."
  },
  leaderboard: {
    title: "Apotheken-Rangliste",
    subtitle:
      "Sehen Sie, welche Apotheken die meisten Tests abgeschlossen haben. Apothekennamen werden für die Admin-Übersicht angezeigt.",
    thisMonth: "Dieser Monat",
    lastMonth: "Letzter Monat",
    thisWeek: "Diese Woche",
    lastWeek: "Letzte Woche",
    periodRange: "{{start}} bis {{end}}",
    rank: "Platz",
    pharmacy: "Apotheke",
    tests: "Tests",
    outOfPharmacies: "{{total}} Apotheken in der Rangliste",
    testsCompleted: "{{count}} Tests abgeschlossen",
    networkTrends: "Top-Tests im Netzwerk",
    noTrendData: "Noch keine Netzwerk-Trends für diesen Zeitraum.",
    noData: "Noch keine Ranglistendaten für diesen Zeitraum.",
    expand: "Aufklappen",
    collapse: "Einklappen",
    collapsedHint: "Tippen für Details",
    collapsedEmpty: "Noch keine Apotheken für diesen Zeitraum gerankt.",
    loadingSummary: "Rangliste wird geladen…",
    publicTitle: "Apotheken-Rangliste",
    publicLoginHint: "Melden Sie sich an, um die Rangliste zu sehen",
    publicLoginError: "Ungültige E-Mail oder Passwort",
    publicLoadError: "Rangliste konnte nicht geladen werden",
  },
  auth: {
    email: "E-Mail",
    password: "Passwort",
    login: "Anmelden",
  },
  users: {
    title: "Benutzerverwaltung",
    addNew: "Neuen Benutzer hinzufügen",
    editUser: "Benutzer bearbeiten",
    searchPlaceholder: "Nach Name oder E-Mail suchen...",
    serialNumber: "Lfd. Nr.",
    fullName: "Vollständiger Name",
    email: "E-Mail",
    role: "Rolle",
    status: "Status",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    addedOn: "Hinzugefügt am",
    actions: "Aktionen",
    totalRecords: "Gesamtanzahl der Datensätze",
    confirmDelete: "Sind Sie sicher, dass Sie \"{{name}}\" löschen möchten?",
    deleted: "Benutzer gelöscht!",
    userProfile: "Benutzerprofil",
    accountInfo: "Kontoinformationen",
    firstName: "Vorname",
    lastName: "Nachname",
    emailAddress: "E-Mail-Adresse",
    phoneNumber: "Telefonnummer",
    userRole: "Benutzerrolle",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein",
    userCreated: "Benutzer erfolgreich erstellt!",
    userUpdated: "Benutzer erfolgreich aktualisiert!",
    invalidEmail: "E-Mail ist ungültig",
    searchMinChars: "Geben Sie mindestens 3 Zeichen ein, um zu suchen",
    passwordGenerated: "Passwort generiert! Vergessen Sie nicht, es zu kopieren."
  },
  pharmacies: {
    title: "Apothekenverwaltung",
    addNew: "Neue Apotheke hinzufügen",
    editPharmacy: "Apotheke bearbeiten",
    searchPlaceholder: "Nach Apothekenname suchen...",
    serialNumber: "Lfd. Nr.",
    pharmacyName: "Apothekenname",
    owner: "Inhaber",
    location: "Standort",
    status: "Status",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    addedOn: "Hinzugefügt am",
    actions: "Aktionen",
    totalRecords: "Gesamtanzahl der Datensätze",
    confirmDelete: "Sind Sie sicher, dass Sie \"{{name}}\" löschen möchten?",
    deleted: "Apotheke gelöscht!",
    pharmacyDetails: "Apothekendetails",
    contactInfo: "Kontaktinformationen",
    address: "Adresse",
    city: "Stadt",
    postalCode: "Postleitzahl",
    country: "Land",
    phoneNumber: "Telefonnummer",
    emailAddress: "E-Mail-Adresse",
    taxDetails: "Steuerinformationen",
    vatId: "USt-IdNr.",
    registrationNumber: "Registrierungsnummer",
    pharmacyCreated: "Apotheke erfolgreich erstellt!",
    pharmacyUpdated: "Apotheke erfolgreich aktualisiert!",
    enterPharmacyName: "Apothekennamen eingeben",
    description: "Beschreibung",
    street: "Straße",
    houseNumber: "Hausnummer/Gebäudenummer",
    taxId: "Steuer-ID",
    selectExistingUser: "Bestehenden Benutzer auswählen",
    createNewUser: "Neuen Benutzer erstellen",
    searchUsers: "Benutzer suchen...",
    noUsersFound: "Keine Benutzer gefunden",
    userDetails: "Benutzerdetails",
    firstName: "Vorname",
    lastName: "Nachname",
    mobile: "Mobiltelefon",
    email: "E-Mail",
    password: "Passwort",
    generatePassword: "Passwort generieren",
    copyPassword: "Passwort kopieren",
    image: "Apothekenbild",
    markdownSupport: "Unterstützt Markdown-Formatierung für Reichtext.",
    currentAdmin: "Aktueller Administrator",
    currentAdmins: "Aktuelle Administratoren",
    searchResults: "Suchergebnisse",
    typeMinChars: "Geben Sie mindestens 3 Zeichen ein, um zu suchen",
    adminInfo: "Neue Administrator-Informationen",
    pharmacyImage: "Aktuelles Apothekenbild",
    totalCompletedOrders: "Abgeschlossene Tests gesamt",
    totalTestsShort: "Gesamt",
    expandedTestCompleted: "Übersicht der abgeschlossenen Tests",
    staffBookings: "Mitarbeiter-Buchungen",
    nonStaffBookings: "Nicht-Mitarbeiter-Buchungen",
    totalCount: "Gesamtanzahl",
    staffCount: "Mitarbeiter",
    nonStaffCount: "Nicht-Mitarbeiter",
    noTestRecords: "Keine Testdaten für diese Apotheke verfügbar",
    testCountsPeriod: "Zeitraum für Testzahlen",
    testCountsPeriodHint: "Abgeschlossene Tests im gewählten Datumsbereich."
  },
  auth: {
    login: "Anmelden",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    rememberMe: "Angemeldet bleiben",
    signIn: "Anmelden",
    signUp: "Registrieren",
    resetPassword: "Passwort zurücksetzen",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein",
    resetPasswordSuccess: "Passwort erfolgreich zurückgesetzt!",
    resetPasswordError: "Fehler beim Zurücksetzen des Passworts"
  },
  settings: {
    title: "Einstellungen",
    general: "Allgemeine Einstellungen",
    account: "Kontoeinstellungen",
    notifications: "Benachrichtigungen",
    security: "Sicherheit & Datenschutz",
    appearance: "Erscheinungsbild",
    language: "Sprache",
    selectLanguage: "Sprache auswählen",
    english: "Englisch",
    german: "Deutsch",
    darkMode: "Dunkelmodus",
    saveChanges: "Änderungen speichern",
    settingsUpdated: "Einstellungen erfolgreich aktualisiert!",
    billing: "Abrechnung & Rechnungen",
    profileSettings: "Profileinstellungen"
  },
  categories: {
    title: "Kategorien",
    addNew: "Neue Kategorie hinzufügen",
    editCategory: "Kategorie bearbeiten",
    name: "Name",
    description: "Beschreibung",
    image: "Bild",
    active: "Aktiv",
    inactive: "Inaktiv",
    status: "Status",
    confirmDelete: "Sind Sie sicher, dass Sie die Kategorie \"{{name}}\" löschen möchten?",
    categoryCreated: "Kategorie erfolgreich hinzugefügt",
    categoryUpdated: "Kategorie erfolgreich aktualisiert",
    enterName: "Kategoriename eingeben"
  },
  labTests: {
    title: "Labortests",
    addNew: "Labortest hinzufügen",
    editLabTest: "Labortest bearbeiten",
    name: "Testname",
    description: "Beschreibung",
    price: "Preis",
    duration: "Dauer",
    status: "Status",
    actions: "Aktionen",
    savePackage: "Paket speichern",
    saveTest: "Test speichern",
    next: "Weiter",
    ageRange: "Alter",
    deleteConfirmation: "Sind Sie sicher, dass Sie den Test löschen wollen?"
  },
  dnaSamples: {
    title: "PDFs hochladen",
    searchPlaceholder: "Nach Name, E-Mail, Telefon, Proben-ID oder ID suchen...",
    totalRecords: "Gesamtanzahl der Datensätze",
    loading: "Wird geladen...",
    errorLoading: "Fehler beim Laden der DNA-Einreichungen: {{error}}",
    retry: "Wiederholen",
    noSubmissionsFound: "Keine DNA-Einreichungen gefunden.",
    noSubmissionsMatching: "Keine Einreichungen gefunden, die Ihrer Suche entsprechen.",
    tableHeaders: {
      serialNumber: "#",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      sampleId: "Proben-ID",
      type: "Typ",
      status: "Status",
      resultStatus: "Ergebnisstatus",
      resultUploaded: "Ergebnis hochgeladen",
      created: "Erstellt",
      actions: "Aktionen"
    },
    status: {
      active: "Aktiv",
      inactive: "Inaktiv",
      available: "Verfügbar",
      pending: "Ausstehend"
    },
    actions: {
      viewDetails: "Details anzeigen",
      uploadResult: "Ergebnis hochladen",
      resendEmail: "E-Mail erneut senden",
      viewResult: "Ergebnis anzeigen",
      downloadResult: "Ergebnis herunterladen"
    },
    modals: {
      detailsTitle: "PDFs hochladen",
      uploadResultTitle: "PDFs hochladen"
    },
    notifications: {
      emailSentSuccess: "E-Mail erfolgreich gesendet",
      emailSendFailed: "Fehler beim Senden der E-Mail"
    },
    pagination: {
      previous: "Zurück",
      next: "Weiter",
      page: "Seite {{current}} von {{total}}"
    },
    detailsModal: {
      loading: "Proben-Details werden geladen...",
      errorLoading: "Fehler beim Laden der Proben-Details: {{error}}",
      retry: "Wiederholen",
      noDetailsFound: "Keine Proben-Details gefunden.",
      personalInformation: "Persönliche Informationen",
      sampleInformation: "Proben-Informationen",
      resultInformation: "Ergebnis-Informationen",
      timestamps: "Zeitstempel",
      additionalInformation: "Zusätzliche Informationen",
      fields: {
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        phone: "Telefon",
        sampleId: "Proben-ID",
        type: "Typ",
        status: "Status",
        resultStatus: "Ergebnisstatus",
        resultUploadedAt: "Ergebnis hochgeladen am",
        createdAt: "Erstellt am",
        updatedAt: "Aktualisiert am"
      },
      actions: {
        close: "Schließen",
        downloadResult: "Ergebnis herunterladen"
      }
    },
    uploadModal: {
      sampleInformation: "Proben-Informationen",
      fileUpload: "Datei-Upload",
      uploadInstructions: "Wählen Sie eine PDF-Datei aus, die als DNA-Testergebnis hochgeladen werden soll",
      selectFile: "PDF-Datei auswählen",
      noFileSelected: "Keine Datei ausgewählt",
      fileSelected: "Datei ausgewählt: {{fileName}}",
      fileSize: "Dateigröße: {{size}}",
      sendEmailNotification: "E-Mail-Benachrichtigung an Patienten senden",
      emailNotificationHelp: "Aktivieren Sie dieses Kontrollkästchen, um automatisch eine E-Mail-Benachrichtigung an den Patienten zu senden, wenn das Ergebnis hochgeladen wird",
      uploadButton: "Ergebnis hochladen",
      uploading: "Wird hochgeladen...",
      cancel: "Abbrechen",
      deleteFile: "Datei löschen",
      fields: {
        sampleId: "Proben-ID",
        patientName: "Patientenname",
        email: "E-Mail",
        phone: "Telefon"
      },
      validation: {
        fileRequired: "PDF-Datei ist erforderlich",
        onlyPdfAllowed: "Nur PDF-Dateien sind erlaubt"
      },
      notifications: {
        uploadSuccess: "Ergebnis erfolgreich hochgeladen",
        uploadFailed: "Fehler beim Hochladen des Ergebnisses"
      }
    }
  },
  labTestBookings: {
    title: "Labortest-Buchungen",
    addNew: "Neue Buchung hinzufügen",
    createBooking: "Buchung erstellen",
    viewBooking: "Buchung anzeigen",
    editBooking: "Buchung bearbeiten",
    patientName: "Patientenname",
    testName: "Testname",
    bookingDate: "Buchungsdatum",
    status: "Status",
    actions: "Aktionen",
    statusOpen: "Offen",
    statusStarted: "Begonnen",
    statusFinished: "Abgeschlossen",
    statusManuallyCancelled: "Manuell storniert",
    statusAutoCancelled: "Automatisch storniert",
    statusUpcoming: "Bevorstehend",
    statusMaybeMissed: "Möglicherweise verpasst",
    changeBookingStatus: "Buchungsstatus ändern",
    reviewBookingDetails: "Buchungsdetails überprüfen",
    editDetails: "Details bearbeiten",
    startTestNow: "Test jetzt starten?",
    barcodeInput: "Code vom Barcodescanner",
    saving: "Wird gespeichert...",
    saveBooking: "Buchung speichern",
    cancel: "Abbrechen",
    yes: "Ja",
    no: "Nein",
    price: "Preis",
    totalPrice: "Gesamtpreis",
    incTax: "inkl. MwSt.",
    selectDateTime: "Datum und Uhrzeit auswählen",
    selectedLabTest: "Ausgewählter Labortest",
    selectedDate: "Ausgewähltes Datum",
    name: "Name",
    email: "E-Mail",
    dateOfBirth: "Geburtsdatum",
    age: "Alter",
    gender: "Geschlecht",
    postalCode: "Postleitzahl",
    bookingDateTime: "Buchungsdatum & Uhrzeit",
    testStarted: "Test wurde erfolgreich gestartet!",
    errorStarting: "Fehler beim Starten der Buchung: {{message}}",
    errorCreating: "Fehler beim Erstellen der Buchung: {{message}}",
    startTest: "Test starten",
    finishTest: "Test abschließen",
    reschedule: "Neu terminieren",
    confirmCancel: "Sind Sie sicher, dass Sie die Buchung für \"{{name}}\" stornieren möchten?",
    starting: "Wird gestartet..."
  },
  calendar: {
    title: "Kalender",
    eventAdded: "Neuer Termin hinzugefügt!"
  },
  transactions: {
    title: "Transaktionen"
  },
  tutorials: {
    title: "Tutorials",
    addNew: "Neues Tutorial hinzufügen",
    addTutorial: "Tutorial hinzufügen",
    editTutorial: "Tutorial bearbeiten",
    viewTutorial: "Tutorial anzeigen",
    searchPlaceholder: "Nach Titel, Beschreibung oder Typ suchen...",
    totalRecords: "Gesamtanzahl der Datensätze",
    loading: "Wird geladen...",
    errorLoading: "Fehler beim Laden der Tutorials: {{error}}",
    retry: "Wiederholen",
    noTutorialsFound: "Keine Tutorials gefunden.",
    noTutorialsMatching: "Keine Tutorials gefunden, die Ihrer Suche entsprechen.",
    tableHeaders: {
      serialNumber: "#",
      title: "Titel",
      description: "Beschreibung",
      type: "Typ",
      content: "Inhalt",
      created: "Erstellt",
      actions: "Aktionen"
    },
    type: {
      pdf: "PDF",
      video: "VIDEO"
    },
    actions: {
      viewDetails: "Details anzeigen",
      editTutorial: "Tutorial bearbeiten",
      deleteTutorial: "Tutorial löschen",
      viewPdf: "PDF anzeigen",
      watchVideo: "Video ansehen"
    },
    modals: {
      addTitle: "Neues Tutorial hinzufügen",
      editTitle: "Tutorial bearbeiten",
      detailsTitle: "Tutorial-Details",
      confirmDelete: "Löschen bestätigen"
    },
    confirmDelete: "Sind Sie sicher, dass Sie \"{{title}}\" löschen möchten?",
    notifications: {
      tutorialCreated: "Tutorial erfolgreich erstellt!",
      tutorialUpdated: "Tutorial erfolgreich aktualisiert!",
      tutorialDeleted: "Tutorial erfolgreich gelöscht!"
    },
    pagination: {
      previous: "Zurück",
      next: "Weiter",
      page: "Seite {{current}} von {{total}}"
    },
    fields: {
      title: "Titel",
      description: "Beschreibung",
      type: "Typ",
      pdfUrl: "PDF-URL",
      videoUrl: "Video-URL",
      created: "Erstellt",
      updated: "Aktualisiert"
    },
    addModal: {
      title: "Titel",
      titleRequired: "Titel ist erforderlich",
      titlePlaceholder: "Tutorial-Titel eingeben",
      description: "Beschreibung (Optional)",
      descriptionPlaceholder: "Beschreibung eingeben",
      type: "Typ",
      typeRequired: "Typ ist erforderlich",
      uploadPdfFile: "PDF-Datei hochladen",
      uploadPdfRequired: "PDF-Datei ist erforderlich",
      videoUrl: "Video-URL",
      videoUrlRequired: "Video-URL ist erforderlich",
      videoUrlPlaceholder: "Video-URL eingeben",
      fileUpload: {
        clickToUpload: "Klicken Sie hier, um PDF hochzuladen",
        dragAndDrop: "oder per Drag & Drop",
        pdfFilesOnly: "Nur PDF-Dateien",
        fileSelected: "Datei ausgewählt: {{fileName}}",
        fileSize: "Dateigröße: {{size}} MB",
        removeFile: "Datei entfernen"
      },
      validation: {
        titleRequired: "Titel ist erforderlich",
        typeRequired: "Typ ist erforderlich",
        fileRequired: "PDF-Datei ist erforderlich",
        videoUrlRequired: "Video-URL ist erforderlich"
      },
      actions: {
        cancel: "Abbrechen",
        createTutorial: "Tutorial erstellen",
        creating: "Wird erstellt..."
      },
      notifications: {
        tutorialCreated: "Tutorial erfolgreich erstellt",
        tutorialCreateFailed: "Fehler beim Erstellen des Tutorials"
      }
    },
    detailsModal: {
      loading: "Tutorial-Details werden geladen...",
      errorLoading: "Fehler beim Laden der Tutorial-Details: {{error}}",
      retry: "Wiederholen",
      noDetailsFound: "Keine Tutorial-Details gefunden.",
      tutorialInformation: "Tutorial-Informationen",
      content: "Inhalt",
      timestamps: "Zeitstempel",
      fields: {
        title: "Titel",
        description: "Beschreibung",
        type: "Typ",
        createdAt: "Erstellt am",
        updatedAt: "Aktualisiert am"
      },
      contentTypes: {
        pdfDocument: "PDF-Dokument",
        videoContent: "Video-Inhalt",
        clickToViewPdf: "Klicken Sie hier, um PDF anzuzeigen",
        clickToWatchVideo: "Klicken Sie hier, um Video anzuschauen"
      },
      actions: {
        close: "Schließen",
        viewPdf: "PDF anzeigen",
        watchVideo: "Video ansehen"
      }
    },
    editModal: {
      loading: "Tutorial-Details werden geladen...",
      title: "Titel",
      titleRequired: "Titel ist erforderlich",
      titlePlaceholder: "Tutorial-Titel eingeben",
      description: "Beschreibung (Optional)",
      descriptionPlaceholder: "Beschreibung eingeben",
      type: "Typ",
      typeRequired: "Typ ist erforderlich",
      uploadPdfFile: "PDF-Datei hochladen",
      uploadPdfRequired: "PDF-Datei ist erforderlich oder bestehende PDF muss vorhanden sein",
      videoUrl: "Video-URL",
      videoUrlRequired: "Video-URL ist erforderlich",
      videoUrlPlaceholder: "Video-URL eingeben",
      currentPdf: "Aktuelle PDF: {{fileName}}",
      currentPdfDescription: "Klicken Sie hier, um anzuzeigen oder neue Datei zum Ersetzen hochzuladen",
      fileUpload: {
        clickToUpload: "Klicken Sie hier, um PDF hochzuladen",
        dragAndDrop: "oder per Drag & Drop",
        pdfFilesOnly: "Nur PDF-Dateien",
        fileSelected: "Datei ausgewählt: {{fileName}}",
        fileSize: "Dateigröße: {{size}} MB",
        removeFile: "Datei entfernen"
      },
      validation: {
        titleRequired: "Titel ist erforderlich",
        typeRequired: "Typ ist erforderlich",
        fileRequired: "PDF-Datei ist erforderlich oder bestehende PDF muss vorhanden sein",
        videoUrlRequired: "Video-URL ist erforderlich"
      },
      actions: {
        cancel: "Abbrechen",
        updateTutorial: "Tutorial aktualisieren",
        updating: "Wird aktualisiert...",
        view: "Anzeigen"
      },
      notifications: {
        tutorialUpdated: "Tutorial erfolgreich aktualisiert",
        tutorialUpdateFailed: "Fehler beim Aktualisieren des Tutorials"
      }
    },
    folders: {
      root: "Alle Tutorials",
      newFolder: "Neuer Ordner",
      createFolder: "Ordner erstellen",
      createTitle: "Neuen Ordner erstellen",
      editTitle: "Ordner umbenennen",
      editFolder: "Ordner bearbeiten",
      deleteFolder: "Ordner löschen",
      folderName: "Ordnername",
      folderNamePlaceholder: "Ordnername eingeben",
      folderLabel: "Ordner",
      emptyFolder: "Dieser Ordner ist leer.",
      creating: "Wird erstellt...",
      saving: "Wird gespeichert...",
      confirmDeleteTitle: "Ordner löschen",
      confirmDelete: "Möchten Sie \"{{name}}\" und alle Inhalte wirklich löschen?",
      validation: {
        nameRequired: "Ordnername ist erforderlich"
      },
      notifications: {
        created: "Ordner erfolgreich erstellt",
        createFailed: "Fehler beim Erstellen des Ordners",
        updated: "Ordner erfolgreich umbenannt",
        updateFailed: "Fehler beim Umbenennen des Ordners"
      }
    }
  },
  testResults: {
    title: "Testergebnisse",
    subtitle: "Abgeschlossene Laborergebnisse aller Apotheken — eine Zeile pro Testergebnis.",
    searchPlaceholder: "Suche nach Name, E-Mail, Apotheke, Test oder Barcode...",
    rowsPerPage: "Zeilen pro Seite",
    exportCsv: "CSV exportieren",
    exportSuccess: "CSV erfolgreich exportiert",
    exportFailed: "CSV-Export fehlgeschlagen",
    showingRows: "{{from}}–{{to}} von {{total}} angezeigt",
    columns: {
      date: "Datum",
      time: "Uhrzeit",
      pharmacy: "Apotheke",
      gender: "Geschlecht",
      birthday: "Geburtstag",
      test: "Test",
      result: "Ergebnis",
      resultText: "Ergebnistext",
      color: "Farbe",
      price: "Preis",
    },
  },
};

export default locale; 